/**
 * 現場データ
 */
export interface Site {
  readonly id: number;
  readonly siteName: string;
}

/**
 * 盤データ（現場に紐づく）
 */
export interface Panel {
  readonly id: number;
  readonly panelName: string;
  readonly siteId: number;
  readonly siteName: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

/**
 * 盤移動理由
 */
export type PanelTransferReason = 'CONSTRUCTION_COMPLETE' | 'MAINTENANCE' | 'OTHER';

/**
 * 移動理由ラベルマッピング
 */
export const TRANSFER_REASON_LABELS: Readonly<Record<PanelTransferReason, string>> = {
  CONSTRUCTION_COMPLETE: '工事完了',
  MAINTENANCE: '機器メンテナンス',
  OTHER: 'その他',
} as const;

/**
 * 移動理由選択肢
 */
export const TRANSFER_REASON_OPTIONS: ReadonlyArray<{
  readonly value: PanelTransferReason;
  readonly label: string;
}> = [
  { value: 'CONSTRUCTION_COMPLETE', label: '工事完了' },
  { value: 'MAINTENANCE', label: '機器メンテナンス' },
  { value: 'OTHER', label: 'その他' },
] as const;

/**
 * 盤移動リクエストパラメータ
 */
export interface TransferPanelParams {
  readonly panelId: number;
  readonly targetSiteId: number;
  readonly transferReason: PanelTransferReason;
  readonly note?: string;
}

/**
 * 盤移動結果
 */
export interface TransferPanelResult {
  readonly success: boolean;
  readonly panel: {
    readonly id: number;
    readonly panelName: string;
    readonly siteId: number;
    readonly siteName: string;
  };
  readonly message: string;
}

/**
 * 盤の現場履歴アイテム
 */
export interface PanelSiteHistoryItem {
  readonly id: number;
  readonly siteId: number;
  readonly siteName: string;
  readonly startedAt: string;
  readonly endedAt: string | null;
  readonly transferReason: PanelTransferReason;
  readonly transferReasonLabel: string;
  readonly note: string | null;
  readonly performedBy: {
    readonly id: string;
    readonly userName: string;
  };
}

/**
 * 盤の現場履歴取得結果
 */
export interface PanelSiteHistoryResult {
  readonly success: boolean;
  readonly panelId: number;
  readonly panelName: string;
  readonly currentSite: {
    readonly id: number;
    readonly siteName: string;
  };
  readonly history: readonly PanelSiteHistoryItem[];
}

/**
 * 現場の盤履歴アイテム
 */
export interface SitePanelHistoryItem {
  readonly id: number;
  readonly panelId: number;
  readonly panelName: string;
  readonly startedAt: string;
  readonly endedAt: string | null;
  readonly transferReason: PanelTransferReason;
  readonly transferReasonLabel: string;
}

/**
 * 現場の盤履歴取得結果
 */
export interface SitePanelHistoryResult {
  readonly success: boolean;
  readonly siteId: number;
  readonly siteName: string;
  readonly currentPanels: readonly {
    readonly id: number;
    readonly panelName: string;
  }[];
  readonly history: readonly SitePanelHistoryItem[];
}
